import { createContext, useContext, useState, useEffect } from "react"
import { contentAPI } from "../services/contentService"
import { serviceAPI } from "../services/serviceService"

const SiteContext = createContext()

export const useSiteContext = () => {
  const context = useContext(SiteContext)
  if (!context) {
    throw new Error("useSiteContext must be used within a SiteProvider")
  }
  return context
}

export const SiteProvider = ({ children }) => {
  const [siteData, setSiteData] = useState({
    hero: {
      title: "Profesyonel Doğalgaz Tesisat Hizmeti",
      subtitle: "Deneyimli ekibimizle ev ve işyerleriniz için güvenli ve kaliteli doğalgaz tesisat çözümleri sunuyoruz.",
      features: [
        "Montaj & Kurulum",
        "Bakım & Onarım", 
        "Proje Danışmanlığı"
      ]
    },
    services: [],
    projects: [
      {
        title: "Lüks Villa Doğalgaz Tesisatı",
        location: "Beşiktaş, İstanbul",
        date: "2024",
        description: "Modern villa için komple doğalgaz tesisat sistemi kurulumu. Merkezi sistem ve bireysel kombi montajı.",
        image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
        tags: ["Villa", "Merkezi Sistem", "Kombi"]
      },
      {
        title: "Apartman Doğalgaz Dönüşümü",
        location: "Kadıköy, İstanbul", 
        date: "2024",
        description: "24 daireli apartmanda kömürden doğalgaza dönüşüm projesi. Tüm izin işlemleri ve montaj dahil.",
        image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
        tags: ["Apartman", "Dönüşüm", "Toplu Konut"]
      },
      {
        title: "İşyeri Doğalgaz Sistemi",
        location: "Şişli, İstanbul",
        date: "2023", 
        description: "Ofis binası için doğalgaz tesisat kurulumu ve merkezi ısıtma sistemi montajı.",
        image: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&h=250",
        tags: ["İşyeri", "Merkezi Isıtma", "Ofis"]
      }
    ],
    about: {
      title: "Hakkımızda",
      description: "Buğra Teknik Servis olarak 2010 yılında Karabük İlinde kurulduk. Profesyonel ve kendi dalında uzman arkadaşlarımızla Karabük ve İlçelerine sabah 09:00 gece 21:00 arası hizmet vermekteyiz.",
      stats: [
        { number: "14+", label: "Yıl Deneyim" },
        { number: "1000+", label: "Mutlu Müşteri" },
        { number: "500+", label: "Tamamlanan İş" },
        { number: "100%", label: "Müşteri Memnuniyeti" }
      ],
      services: [
        "Doğal Gaz ve Su Tesisatı",
        "Kaçak Su Tespiti", 
        "Kalorifer Tesisatı",
        "Kombi Bakım Onarım",
        "Klima Servisi",
        "Beyaz Eşya Servisi",
        "Kart Tamiri",
        "Yedek Parça Hizmeti"
      ]
    },
    contact: {
      phone: "0533 428 70 27",
      email: "ramazanbasol74@gmail.com",
      address: "Şirinevler Mahallesi, Bestekar Sokak No:20, Karabük/Merkez",
      workingHours: "Pazartesi - Cumartesi: 09:00 - 21:00"
    }
  })

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchSiteData = async () => {
    try {
      setLoading(true)
      setError(null)
      
      // Hizmetleri API'den çek
      const servicesResponse = await serviceAPI.getActiveServices()
      setSiteData(prev => ({
        ...prev,
        services: servicesResponse || []
      }))
      
    } catch (error) {
      setError("Site verileri yüklenirken bir hata oluştu")
      console.error("Fetch site data error:", error)
      // Fallback data kullan
      setSiteData(prev => ({
        ...prev,
        services: prev.services || []
      }))
    } finally {
      setLoading(false)
    }
  }

  const updateSiteData = (section, data) => {
    setSiteData(prev => ({
      ...prev,
      [section]: data
    }))
  }

  useEffect(() => {
    fetchSiteData()
  }, [])

  const value = {
    siteData,
    loading,
    error,
    updateSiteData,
    fetchSiteData
  }

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  )
} 